import { render, staticRenderFns } from "./list_cards.vue?vue&type=template&id=3ec54e3e"
import script from "./list_cards.vue?vue&type=script&lang=js"
export * from "./list_cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports